import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-bg-primary text-text-primary font-sans selection:bg-brand-primary selection:text-black">
      <Navbar />
      <div className="pt-32 pb-24 px-6 lg:px-[7.69%] max-w-[1000px] mx-auto">
        <h1 className="display-large mb-8 text-brand-primary">Terms of Service</h1>
        <p className="body-medium text-text-muted mb-8">Last Updated: August 2025</p>

        <div className="space-y-8 body-medium text-text-secondary">
          <section>
            <h2 className="heading-2 text-white mb-4">1. Agreement to Terms</h2>
            <p>By accessing our website at Falcon42, you agree to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site.</p>
          </section>

          <section>
            <h2 className="heading-2 text-white mb-4">2. Use License</h2>
            <p>Permission is granted to temporarily download one copy of the materials (information or software) on Falcon42's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>modify or copy the materials;</li>
              <li>use the materials for any commercial purpose, or for any public display (commercial or non-commercial);</li>
              <li>attempt to decompile or reverse engineer any software contained on Falcon42's website;</li>
              <li>remove any copyright or other proprietary notations from the materials; or</li>
              <li>transfer the materials to another person or "mirror" the materials on any other server.</li>
            </ul>
          </section>

          <section>
            <h2 className="heading-2 text-white mb-4">3. Disclaimer</h2>
            <p>The materials on Falcon42's website are provided on an 'as is' basis. Falcon42 makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
          </section>

          <section>
            <h2 className="heading-2 text-white mb-4">4. Limitations</h2>
            <p>In no event shall Falcon42 or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Falcon42's website, even if Falcon42 or a Falcon42 authorized representative has been notified orally or in writing of the possibility of such damage.</p>
          </section>

          <section>
            <h2 className="heading-2 text-white mb-4">5. Governing Law</h2>
            <p>These terms and conditions are governed by and construed in accordance with the laws of Delaware and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.</p>
          </section>

          <section>
            <h2 className="heading-2 text-white mb-4">6. Corporate Information</h2>
            <div className="mt-4 p-4 border border-border-subtle bg-bg-secondary">
              <p><strong>Falcon42</strong></p>
              <p>245, 4 Peddlers Row</p>
              <p>Newark, DE 19702</p>
              <p>EIN: 37-2144924</p>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
